import { project } from './initializeStats';
import { getIndex } from './helpers';

export function sendStats(category, action, label, value) {
	if (value) {
		try {
			WP.stat.show(
				wp_sn,
				{
					category,
					label,
					value,
					asproduct,
					asorderid,
					asname,
				},
				action,
			);
		} catch (e) {
			console.log(`stat.show ERROR: ${e}`);
		}
	} else {
		try {
			WP.stat.show(
				wp_sn,
				{
					category,
					label,
					asproduct,
					asorderid,
					asname,
				},
				action,
			);
		} catch (e) {
			console.log(`stat.show ERROR: ${e}`);
		}
	}
}

// Statystyki kliknięć w linki oparte o atrybut data-ga360-click.
//
// Sposób użycia (dowolny link, np. przycisk .main__btn):
//
//   Wariant prosty - cała wartość to eventCategory (event, action i label wyliczane automatycznie):
//     <a href="..." data-ga360-click="read_more">Zagłosuj</a>
//
//   Wariant pełny - jawnie ustawiamy wszystkie cztery parametry:
//     <a href="..." data-ga360-click="event: site_interaction, eventCategory: cross_link, eventAction: click, eventLabel: artykul_zaglosuj">Zagłosuj</a>
//
//   Wariant częściowy - podajemy tylko wybrane pola, reszta ma wartości domyślne
//   (event -> 'site_interaction', eventAction -> 'click'/'tap', eventLabel -> 'header'/'footer'/window.location.href):
//     <a href="..." data-ga360-click="eventCategory: cross_link, eventLabel: artykul_zaglosuj">Zagłosuj</a>

// Parsuje wartość data-ga360-click.
// "read_more"                                     -> { eventCategory: 'read_more' }
// "event: x, eventCategory: y, eventAction: z..." -> { event: 'x', eventCategory: 'y', ... }
function parseGa360Click(raw) {
	const value = (raw || '').trim();
	// Format strukturalny rozpoznajemy po obecności którejś z nazwanych właściwości.
	if (/(^|,)\s*(event|eventCategory|eventAction|eventLabel)\s*:/.test(value)) {
		const parsed = {};
		value.split(',').forEach((pair) => {
			const idx = pair.indexOf(':');
			if (idx === -1) return;
			const key = pair.slice(0, idx).trim();
			const val = pair.slice(idx + 1).trim();
			if (['event', 'eventCategory', 'eventAction', 'eventLabel'].includes(key) && val) {
				parsed[key] = val;
			}
		});
		return parsed;
	}
	// Stare zachowanie: cała wartość to eventCategory.
	return { eventCategory: value };
}

export function linkStats() {
	document.querySelectorAll('[data-ga360-click]').forEach((el) => {
		const clickEvent = function (ev) {
			el.addEventListener(ev, function () {
				const params = parseGa360Click(this.getAttribute('data-ga360-click'));

				const event = params.event || 'site_interaction';
				const eventCategory = params.eventCategory;
				const eventAction = params.eventAction
					|| ('ontouchstart' in document.documentElement ? 'tap' : 'click');
				let eventLabel = params.eventLabel;
				if (!eventLabel) {
					if (this.closest('.header')) {
						eventLabel = 'header';
					} else if (this.closest('.footer')) {
						eventLabel = 'footer';
					} else {
						eventLabel = window.location.href;
					}
				}

				window.dataLayer = window.dataLayer || [];
				window.dataLayer.push({
					"event": event,
					"eventCategory": eventCategory,
					"eventAction": eventAction,
					"eventLabel": eventLabel
				});

				sendStats(eventCategory, eventAction, eventLabel);
			});
		};
		clickEvent('click');
		clickEvent('auxclick');
		clickEvent('contextmenu');
	});
}


export function shareStats() {
	document.querySelectorAll('.__js_socialShare').forEach((el) => {
		el.addEventListener('click', function (e) {
			e.preventDefault();
			const eventCategory = this.getAttribute('data-id');
			const href = this.getAttribute('data-href');
			const eventAction = 'ontouchstart' in document.documentElement ? 'tap' : 'click';
			let ga360Socials;
			const eventLabel = window.location.href;
			if (eventCategory === 'facebook') {
				window.open(
					href,
					'_blank',
					'top=100, left=300, width=320,height=320,toolbar=1,resizable=0',
				);
				ga360Socials = 'share_FB';
			}
			if (eventCategory === 'instagram') {
				window.open(
					href,
					'_blank',
					'top=100, left=300, width=320,height=320,toolbar=1,resizable=0',
				);
				ga360Socials = 'share_Instagram';
			}
			if (eventCategory === 'twitter') {
				window.open(
					href,
					'_blank',
					'top=100, left=300, width=320,height=320,toolbar=1,resizable=0',
				);
				ga360Socials = 'share_Twitter';
			}
			if (eventCategory === 'linkedin') {
				window.open(
					href,
					'_blank',
					'top=100, left=300, width=320,height=320,toolbar=1,resizable=0',
				);
				ga360Socials = 'share_Linkedin';
			}
			if (eventCategory === 'tiktok') {
				window.open(href, '_blank', 'noopener');
				ga360Socials = 'share_TikTok';
			}

			window.dataLayer = window.dataLayer || [];
			window.dataLayer.push({
				event: 'site_interaction',
				eventCategory: ga360Socials,
				eventAction: eventAction,
				eventLabel: eventLabel
			});

			sendStats(eventCategory, eventAction, eventLabel);
		});
	});
}

export function setStatElementCollector() {
	document.querySelectorAll('[data-ga360-id]').forEach(function (el) {
		const artId = el.closest('article').getAttribute('data-id');
		const ga360id = el.getAttribute('data-ga360-id');
		if (ga360id === undefined) {
			console.log(
				`%c dodać ga360-id do Galerii hover: ${this.getAttribute('data-id')}`,
				'background: #553311; padding: 3px; color: #ffaaaa',
			);
		} else {
			project.statElementCollector[`${ga360id}-${artId}`] = {
				id: ga360id,
				moduleName: el.getAttribute('data-id'),
				viewedCount: 0,
				itemCount: el.querySelectorAll('.widget__item').length,
			};
		}
		el.statVievedSlide = [];
		project.slidePositionVieved[`${ga360id}-${artId}`] = {};
	});
}

export function statsOnWidgetInteraction(item, arg, idx, evType) {
	const artId = item.closest('article').getAttribute('data-id');
	const ga360id = item.closest('[data-ga360-id]').getAttribute('data-ga360-id');
	const dataId = item.closest('[data-id]').getAttribute('data-id');
	const isClick = !!item.closest('.gallery-slider');
	const hoverEventType = 'ontouchstart' in document.documentElement ? 'tap' : 'hover';

	const itemId = arg;
	if (!ga360id) {
		console.log(
			`%c dodać ga360-id do ${dataId}background: #3b3b3b; padding: 3px; color: #beeb2f`,
		);
	}
	const index = idx || getIndex(item);

	if (!project.isScrollingFlag) {
		project.slidePositionVieved[`${ga360id}-${artId}`][index] = 1;
		project.statElementCollector[`${ga360id}-${artId}`].viewedCount = Object.keys(project.slidePositionVieved[`${ga360id}-${artId}`]).length;
		sendStats(
			'gallery',
			`${isClick && evType ? evType : hoverEventType}-${index}`,
			`${artId} / ${dataId}`,
			itemId,
		);
		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push({
			event: 'content_interaction',
			eventCategory: ga360id,
			moduleName: dataId,
			eventAction: isClick && evType ? evType : hoverEventType,
		});
	}
}
